<template>
    <div>
        <v-overlay :value="loading.data" opacity="0" z-index="4">
            <v-progress-circular
                indeterminate
                size="64"
                color="primary">
            </v-progress-circular>
        </v-overlay>
        <v-card
            flat
            v-if="!loading.data">
            <v-card-title>
                {{ $t('USERS_PAGE_TITLE') }}
                <v-spacer></v-spacer>
                <v-text-field
                    :label="$t('USERS_PAGE_SEARCH')"
                    v-model="search"
                    prepend-icon="mdi-magnify"
                    hide-details>                    
                </v-text-field>
                <v-menu
                    offset-y>
                    <template v-slot:activator="{on}">
                        <v-btn
                            icon
                            v-on="on"
                            class="mx-1">
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>
                    <v-list dense >
                        <v-list-item
                            link
                            v-if="authorizations.users.create"
                            @click="openUserDialog({editMode: false})"
                            >
                            <v-list-item-avatar>
                                <v-icon>mdi-plus-circle</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-title>
                                {{ $t('new_user') }}
                            </v-list-item-title>
                        </v-list-item>
                         <v-list-item
                            v-if="authorizations.users.update && selected.user.length == 1"
                            link
                            @click="openUserDialog({editMode: true, id: selected.user[0].id})"
                            :disabled="!selected.user[0].meta.editable">
                            <v-list-item-avatar>
                                <v-icon :disabled="!selected.user[0].meta.editable">mdi-pencil</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title>{{ $t('ACTIONS_MENU_EDIT') }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item
                            v-if="authorizations.users.delete && selected.user.length == 1"
                            link
                            @click="openUserDeleteDialog(selected.user[0].id)"
                            :disabled="!selected.user[0].meta.deletable">
                            <v-list-item-avatar>
                                <v-icon :disabled="!selected.user[0].meta.deletable">mdi-delete</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title>{{ $t('ACTIONS_MENU_DELETE') }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-card-title>
            <v-card-subtitle>{{ $t('USERS_PAGE_SUBTITLE') }}</v-card-subtitle>
            <v-card-text>
                <v-data-table
                    single-select
                    show-select
                    @click:row="openUserDisplayDialog"
                    v-model="selected.user"
                    :headers="usersHeaders"
                    :items="users"
                    :search="search">
                    <template v-slot:item.inactive="{item}">
                        {{ item.inactive ? "Inactive" : "Active" }}
                    </template>
                </v-data-table> 
            </v-card-text>
        </v-card>
        <UserDialog
            ref="userDialog"/>
        <DecisionDialog
            ref="decisionDialog"
            @submit="submitDecisionDialog"/>
        <AlertDialog
            ref="alertDialog"/>
        <UserDisplayDialog
            ref="userDisplayDialog"/>
        <RetryDialog
            ref="retryDialog"
            @submit="submitRetryDialog"/>
    </div>
</template>

<script>
import UserDialog from '../components/UserDialog';
import DecisionDialog from '../components/DecisionDialog';
import AlertDialog from '../components/AlertDialog';
import UserDisplayDialog from '../components/UserDisplayDialog';
import RetryDialog from '../components/RetryDialog';
import { mapActions, mapState } from 'vuex';
export default {
    name: "User",
    components: {
        UserDialog,
        DecisionDialog,
        AlertDialog,
        UserDisplayDialog,
        RetryDialog
    },
    data() {
        return {
            search: null,
            selected: {
                user: []
            },
            usersHeaders: [
                {text: null, value: "view"},
                {text: this.$t('USER_NAME'), value: "name"},
                {text: this.$t('USER_USERNAME'), value: "username"},
                {text: this.$t('USER_LAST_LOGIN'), value: "last_login"},
                {text: this.$t('USER_STATE'), value: "inactive"}
            ],
            loading: {
                data: true
            }
        }
    },
    computed: {
        ...mapState("user", ["users"]),
        ...mapState("authentication", ["loggedInUser", "authorizations"])
    },
    methods: {
        ...mapActions("user", ["fetchUsers", "removeUser"]),
        openUserDialog(params) {
            this.$refs.userDialog.open(params);
        },
        openUserDisplayDialog(params) {
            this.$refs.userDisplayDialog.open(params);
        },
        openUserDeleteDialog(id) {
            this.$refs.decisionDialog.open({
                title: this.$t('DELETE_CONFIRM_TITLE'),
                content: this.$t('DELETE_CONFIRM_CONTENT'),
                action: "DELETE_USER",
                id: id
            });
        },
        submitDecisionDialog(payload) {
            if(payload.action == "DELETE_USER") {
                this.removeUser(payload.id)
                    .then(response => {
                        this.fetchUsers();
                        this.$refs.alertDialog.open(this.$t('SUCCESS_TITLE'), response.message);
                    })
                    .catch(error => {
                        this.$refs.alertDialog.open(this.$t('ERROR_TITLE'), error.message);
                    })
            }
        },
        async createdFetchData() {
            try {
                await this.fetchUsers();
                this.loading.data = false;
            } catch (error) {
                let message = null;
                if(error.response) message = error.response.data.message;
                else message = error;
                this.$refs.retryDialog.open({target: "createdFetchData", message});
            }
        },
        submitRetryDialog(params) {
            if(params.target == "createdFetchData") {
                if(params.retry == true) this.createdFetchData();
            }
        }
    },
    created() {
        this.createdFetchData();
    }
}
</script>